import { Component } from "react";

import PropTypes from "prop-types";

import Sentry from "../Sentry";

const propTypes = {
  children: PropTypes.node,
};

// An error boundary component that forwards errors to the Sentry logs.
class SentryErrorBoundary extends Component {
  componentDidCatch(error) {
    Sentry.captureException(error);
  }

  render() {
    return this.props.children;
  }
}

SentryErrorBoundary.propTypes = propTypes;

export default SentryErrorBoundary;
